import React from 'react';
import { BrutalistButton } from './BrutalistUI';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const CategoryFilter = ({ categories, selectedCategory, onSelectCategory }) => {
  return (
    <div className="flex flex-wrap gap-3 items-center">
      <div className="flex items-center gap-2 bg-black text-white px-3 py-2 border-2 border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] text-xs font-black uppercase italic tracking-tighter">
        <SafeIcon icon={FiIcons.FiFilter} />
        Filter By:
      </div>
      
      <div className="flex flex-wrap gap-2">
        <BrutalistButton 
          active={selectedCategory === 'ALL'} 
          onClick={() => onSelectCategory('ALL')}
          className="!px-4 !py-1.5 !text-xs"
        >
          ALL
        </BrutalistButton>
        
        {categories.map(({ name, count }) => (
          <button
            key={name}
            onClick={() => onSelectCategory(name)}
            className={`
              flex items-center gap-2 border-2 border-black px-4 py-1.5 font-bold uppercase tracking-wider text-xs transition-all duration-100
              ${selectedCategory === name 
                ? 'bg-black text-white translate-x-0.5 translate-y-0.5 shadow-[1px_1px_0px_0px_rgba(0,0,0,1)]' 
                : 'bg-white text-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:-translate-y-0.5 hover:shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] active:translate-x-1 active:translate-y-1 active:shadow-none'
              }
            `}
          >
            {name}
            <span className={`
              px-1.5 py-0.5 text-[10px] font-black border-2 border-black
              ${selectedCategory === name ? 'bg-white text-black' : 'bg-black text-white'}
            `}>
              {count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;